import React, { useEffect, useState } from 'react';
import { TApiParameter } from '../../../api/endpoints/Parameter';
import { TParamOption } from '../../../api/endpoints/SubsetOption';
import Checkbox from '../../Inputs/Checkbox/Checkbox';
import CheckboxWrap from '../../Ui/CheckboxWrap';
import ParamLabel from '../../ParamLabel';
import { SelectMultiInput } from '../../Inputs/SelectInput';
import * as Api from '../../../api';
import { sortBy } from 'lodash';
import SelectAllControl from "../SelectAllControl";

const paramToOption = (param: TApiParameter) => {
  return {
    value: param.shortname,
    label: param.name,
    meta: param
  };
};

const filterParamsByShortnames = (params: Array<TApiParameter>, shortnames: Array<string>): Array<TApiParameter> => {
  return params.filter(param => shortnames.includes(param.shortname.toUpperCase()))
}

const ParamsSelector = (props: {
  values: Array<string>;
  spec: TParamOption;
  onChange: (values: Array<string>) => void
}) => {
  const { spec, values, onChange } = props;
  const options = spec.value.param;

  const [showAll, setShowAll] = useState(false);
  const [paramList, setParamList] = useState<Array<TApiParameter>>([]);

  useEffect(() => {
    Api.Parameter.list().then(params => {
      const availableParams = sortBy(filterParamsByShortnames(params, options), param => param.name)
      setParamList(availableParams);
    });
  }, [options]);

  const selectedParams = filterParamsByShortnames(paramList, values);

  const onSelectChange = (options: Array<TApiParameter>) => {
    const shortnames = options.map(option => option.shortname.toUpperCase());
    onChange(shortnames);
  }

  const onCheckboxChange = (value: string, checked: boolean) => {
    onChange(checked ? [...values, value] : values.filter(v => v !== value));
  };

  return (
    <div>
      <SelectAllControl onChange={onChange} values={options} className="margin-bottom-xs" />

      <div className="params margin-bottom-xs">
        <SelectMultiInput
          items={paramList}
          itemToOption={paramToOption}
          onChange={onSelectChange}
          selectedItems={selectedParams}
          name="params"
          menuPlacement="top"
          formatOptionLabel={option => <ParamLabel param={option.meta} />}
        />
      </div>

      <div>
        <button className="btn__links" type="button" onClick={() => setShowAll(!showAll)}>
          {showAll ? 'Hide' : 'Show'} all parameters
        </button>
      </div>

      {showAll && (
        <div>
          <CheckboxWrap>
            {
              paramList.map(param =>
                <Checkbox
                  key={param.id}
                  label={<ParamLabel param={param} short />}
                  value={param.shortname}
                  checked={values.includes(param.shortname.toUpperCase())}
                  name="step-ranges"
                  onChange={(checked) => onCheckboxChange(param.shortname.toUpperCase(), checked)}
                />)
            }
          </CheckboxWrap>
        </div>
      )}
    </div>
  );
};

export default ParamsSelector;
